const { emptySyncMeta, markDirty, queueDelete } = require("../../shared/syncState.js");

const STORE_DOC_TYPES = {
  todo_lists: "todo_list",
  repeating_events: "repeating_event",
  repeating_events_by_date: "repeating_event_by_date",
};

function docKeyFromStore(table, id) {
  const docType = STORE_DOC_TYPES[table];
  if (!docType) throw new Error("Unknown table: " + table);
  return { docType: docType, docId: id };
}

function storageKeyFromLocal(key) {
  if (key === "config") return { docType: "config", docId: "config" };
  if (key === "customTodoListIds") return { docType: "custom_list_ids", docId: "customTodoListIds" };
  throw new Error("Unknown table: " + key);
}

function docIdentity(name, id) {
  if (id === undefined) return storageKeyFromLocal(name);
  return docKeyFromStore(name, id);
}

function loadMeta() {
  const raw = localStorage.getItem("syncMeta");
  if (!raw) return emptySyncMeta();
  const meta = JSON.parse(raw);
  if (!meta.docs || typeof meta.docs !== "object") meta.docs = {};
  if (!Array.isArray(meta.deletes)) meta.deletes = [];
  if (!meta.deletedTodos || typeof meta.deletedTodos !== "object") meta.deletedTodos = {};
  return meta;
}

function saveMeta(meta) {
  localStorage.setItem("syncMeta", JSON.stringify(meta));
}

function publishPending(pending) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") return;
  window.dispatchEvent(new CustomEvent("sync-status", { detail: { pending: pending === true } }));
}

function noteLocalWrite(name, id) {
  if (typeof localStorage === "undefined") return;
  const identity = docIdentity(name, id);
  saveMeta(markDirty(loadMeta(), identity.docType, identity.docId));
  publishPending(true);
}

function noteLocalDelete(name, id) {
  if (typeof localStorage === "undefined") return;
  const identity = docIdentity(name, id);
  saveMeta(queueDelete(loadMeta(), identity.docType, identity.docId));
  publishPending(true);
}

module.exports = {
  docIdentity,
  docKeyFromStore,
  storageKeyFromLocal,
  loadMeta,
  saveMeta,
  noteLocalWrite,
  noteLocalDelete,
};
